export const PAYMENT_ORDERS_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Nome do motorista',
    accessor: 'driver.username',
    type: 'string',
  },
  {
    Header: 'Telefone do motorista',
    accessor: 'driver.phoneNumber',
    type: 'string',
  },
  {
    Header: 'Distribuidora',
    accessor: 'distributor.name',
    type: 'string',
  },
  {
    Header: 'Numeros de carga',
    accessor: 'description',
    type: 'string',
  },
  {
    Header: 'Valor',
    accessor: 'amount',
    type: 'price',
  },
  {
    Header: 'Nfe status',
    accessor: 'status',
    type: 'string',
  },
  {
    Header: 'Data de criação',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const PAYMENT_ORDER_GROUPS_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Valor',
    accessor: 'amount',
    type: 'price',
  },
  {
    Header: 'Aprovado por',
    accessor: 'verifiedBy.username',
    type: 'string',
  },
  {
    Header: 'Aprovado em',
    accessor: 'verifiedAt',
    type: 'date',
  },
  {
    Header: 'Criado em',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const DASHBOARD_ADMIN_HEADERS = [
  {
    Header: 'Número da carga',
    accessor: 'id',
  },
  {
    Header: 'Empresa',
    accessor: 'enterprise_id',
  },
  {
    Header: 'Preço',
    accessor: 'price',
    type: 'price',
  },
  {
    Header: 'Data de Cadastro',
    accessor: 'created_at',
    type: 'date',
  },
  {
    Header: 'Data de Carregamento',
    accessor: 'delivery_limit_date',
    type: 'date',
  },
  {
    Header: 'Tipo de Veículo',
    accessor: 'vehicle_type_id',
  },
];

export const DASHBOARD_HEADERS = [
  {
    Header: 'Número da carga',
    accessor: 'id',
  },
  {
    Header: 'Preço',
    accessor: 'price',
    type: 'price',
  },
  {
    Header: 'Data de Cadastro',
    accessor: 'created_at',
    type: 'date',
  },
  {
    Header: 'Data de Carregamento',
    accessor: 'delivery_limit_date',
    type: 'date',
  },
  {
    Header: 'Tipo de Veículo',
    accessor: 'vehicle_type_id',
  },
];

export const DRIVER_HEADERS = [
  {
    Header: 'id',
    accessor: 'driverId',
    type: 'not_view',
  },
  {
    Header: 'Nome completo',
    accessor: 'username',
  },
  {
    Header: 'Login',
    accessor: 'email',
  },

  {
    Header: 'CPF/CNPJ',
    accessor: 'cpf',
    type: 'cpf/cnpj',
  },
  {
    Header: 'Criado em',
    accessor: 'createdAt',
    type: 'date',
  },

  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const FREIGHTS_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Nº do frete',
    accessor: 'loadNumbers',
  },
  {
    Header: 'Criado em',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    Header: 'Entregas',
    accessor: 'quantityDeliveries',
  },
  {
    Header: 'Peso (Kg)',
    accessor: 'totalWeight',
  },
  {
    Header: 'Valor do frete',
    accessor: 'freightCost',
    type: 'price',
  },
  {
    Header: 'Status',
    accessor: 'freightStatus',
  },
  {
    Header: 'Ação',
    accessor: 'actions',
  },
];

export const INTERNAL_FREIGHTS_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Nº do frete',
    accessor: 'loadNumbers',
  },
  {
    Header: 'Criado em',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    Header: 'Entregas',
    accessor: 'quantityDeliveries',
  },
  {
    Header: 'Peso (Kg)',
    accessor: 'totalWeight',
  },
  {
    Header: 'Status',
    accessor: 'freightStatus',
  },
  {
    Header: 'Ação',
    accessor: 'actions',
  },
];

export const VEHICLE_TYPES_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Nome',
    accessor: 'vehicleType',
  },
  {
    Header: 'Cap. de carga',
    accessor: 'payloadCapacity',
    type: 'tn',
  },
  {
    Header: 'Peso da embalagem',
    accessor: 'packLoadWeight',
    type: 'tn',
  },

  {
    Header: 'Custo por assistente',
    accessor: 'costPerAssistant',
    type: 'price',
  },

  {
    Header: 'Custo do motorista',
    accessor: 'driverCost',
    type: 'price',
  },

  {
    Header: 'Custo por kilometro',
    accessor: 'costPerKilometer',
    type: 'price',
  },

  {
    Header: 'Custo por m³',
    accessor: 'costPerCubicMeter',
    type: 'price',
  },
  {
    Header: 'Custo por pedido',
    accessor: 'costPerOrder',
    type: 'price',
  },
  {
    Header: 'Custo por Ton',
    accessor: 'costPerTon',
    type: 'price',
  },

  {
    Header: 'Criado em',
    accessor: 'createdAt',
    type: 'date',
  },

  {
    Header: 'Atualizado em',
    accessor: 'updatedAt',
    type: 'date',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const GROUNDS_REFUSAL_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Nome',
    accessor: 'name',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const VEHICLES_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Placa',
    accessor: 'license_plate',
  },
  {
    Header: 'Ano',
    accessor: 'year',
  },
  {
    Header: 'Modelo',
    accessor: 'model',
  },
  {
    Header: 'Cap. de carga',
    accessor: 'load_capacity',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const ADMINS_HEADERS = [
  {
    Header: 'id',
    accessor: 'adminId',
    type: 'not_view',
  },
  {
    Header: 'Nome',
    accessor: 'username',
  },
  {
    Header: 'E-mail',
    accessor: 'email',
  },

  {
    Header: 'Criado em ',
    accessor: 'createdAt',
    type: 'date',
  },

  {
    Header: 'Atualizado em: ',
    accessor: 'updatedAt',
    type: 'date',
  },
];

export const DISTRIBUTORS_USERS_HEADERS = [
  {
    Header: 'id',
    accessor: 'distributorUserId',
    type: 'not_view',
  },
  {
    Header: 'Nome',
    accessor: 'username',
  },
  {
    Header: 'E-mail',
    accessor: 'email',
  },

  {
    Header: 'Tipo de usuário',
    accessor: 'distributorUserType',
  },

  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Criado em ',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const RECEIPT_HEADER = [
  {
    Header: 'id',
    accessor: 'orderId',
    type: 'not_view',
  },
  {
    Header: 'Código do Frete',
    accessor: 'orderCode',
  },
  {
    Header: 'Preço',
    accessor: 'price',
    type: 'price',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
    type: 'kg',
  },
  {
    Header: 'Última atualização',
    accessor: 'updatedAt',
    type: 'date',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const DISTRIBUTORS_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'Nome',
    accessor: 'name',
  },
  {
    Header: 'CNPJ',
    accessor: 'cnpj',
    type: 'cpf/cnpj',
  },

  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const FREIGHT_HEADERS = [
  {
    Header: 'id',
    accessor: 'cartId',
    type: 'not_view',
  },
  {
    Header: 'Nota fiscal',
    accessor: 'nf',
  },
  {
    Header: 'PDV',
    accessor: 'corporateName',
  },
  {
    Header: 'Peso Total (Kg)',
    accessor: 'totalWeight',
  },

  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Documentos',
    accessor: 'receiptStatus',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const REPROCESS_HEADERS = [
  {
    Header: 'id',
    accessor: 'cartId',
    type: 'not_view',
  },
  {
    Header: 'Razão social',
    accessor: 'corporateName',
  },
  {
    Header: 'Endereço',
    accessor: 'address',
  },
  {
    Header: 'CEP',
    accessor: 'cep',
  },
  {
    Header: 'Última Atualização',
    accessor: 'updatedAt',
    type: 'date',
  },
  {
    Header: 'Nota fiscal',
    accessor: 'nf',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const SUGESTIONS_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: 'PDV',
    accessor: 'corporateName',
  },
  {
    Header: 'Distancia (Km)',
    accessor: 'distance',
  },
  {
    Header: 'Peso total (Kg)',
    accessor: 'totalWeight',
    type: 'kg',
  },

  {
    Header: 'Criado em',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];

export const CREATE_FREIGHT_HEADERS = [
  {
    Header: 'id',
    accessor: 'id',
    type: 'not_view',
  },
  {
    Header: '#',
    accessor: 'tag',
  },
  {
    Header: 'Razão social',
    accessor: 'name',
  },
  {
    Header: 'Endereço',
    accessor: 'address',
  },
  {
    Header: 'Complemento',
    accessor: 'complement',
  },
  {
    Header: 'Qtd. de pedidos',
    accessor: 'status',
  },
  {
    Header: 'Peso',
    accessor: 'weight',
  },
  {
    Header: 'Valor',
    accessor: 'value',
  },
];

export const REASON_REFUSAL_HEADERS = [
  {
    Header: 'id',
    accessor: 'reasonRefusalId',
    type: 'not_view',
  },

  {
    Header: 'Razão',
    accessor: 'reason',
  },

  {
    Header: 'Descrição',
    accessor: 'description',
  },

  {
    Header: 'Criado em',
    accessor: 'createdAt',
    type: 'date',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
];
